module.exports = require("./zh-Hans-SG.d.ts");